import * as ActionTypes from "./actionTypes"
import rpcCall from '../../util/rpc/rpcCalls'
import {getLoggedInUserId} from '../../loggedInUser/selectors'
import {addCustomers, addProjects, addTasks} from '../../entities/actions'
import {HierarchyLevels} from 'constants'
import actionsGenerator from '../../administration/userManagement/hierarchyAssignmentsPanelTab/actionsGenerator'
import {getTab} from './selectors'

const hierarchyAssignmentsTabActions = actionsGenerator({
    actionTypes: ActionTypes
})

export const setTaskIds = hierarchyAssignmentsTabActions.setTaskIds

export const setProjectIds = hierarchyAssignmentsTabActions.setProjectIds

export const setCustomerIds = hierarchyAssignmentsTabActions.setCustomerIds

export const setTab = hierarchyAssignmentsTabActions.setTab

export const setUserCounters = hierarchyAssignmentsTabActions.setUserCounters

export const setLoading = hierarchyAssignmentsTabActions.setLoading

export const prepareLoadedData = (data, tabType) => (dispatch) => {
    dispatch(addCustomers(data.customers))
    dispatch(addProjects(data.projects))
    dispatch(addTasks(data.tasks))

    dispatch(setUserCounters(data.viewerCounter))

    switch (tabType) {
        case HierarchyLevels.TASK:
            dispatch(setTaskIds(data.taskIds))
            break
        case HierarchyLevels.PROJECT:
            dispatch(setProjectIds(data.projectIds))
            break
        case HierarchyLevels.CUSTOMER:
            dispatch(setCustomerIds(data.customerIds))
            break
    }
}

export const openMenu = (tabType) => (dispatch) => {
    dispatch(setTab(tabType))
}

export const closeMenu = () => (dispatch) => {
    dispatch(setTab(null))
}

export const loadDataAction = () => (dispatch, getState) => {
    const userId = getLoggedInUserId(getState())
    const tab = getTab(getState())
    dispatch(setLoading(true))
    rpcCall('UserManagementService.getViewUserManagementAssignments', [userId, tab])
        .then((data) => {
            dispatch(prepareLoadedData(data.viewAssignmentsData, tab))
            dispatch(setLoading(false))
        })
        .catch((err) => {
            dispatch(setLoading(false))
            // TODO bakharev: add error handling
            console.log(err)
        })
}


// WEBPACK FOOTER //
// ./web/js/userProfile/cptAssignmentsList/actions.js